import { render, staticRenderFns } from "./close.vue?vue&type=template&id=1c6d5bf8&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6d5bf8')) {
      api.createRecord('1c6d5bf8', component.options)
    } else {
      api.reload('1c6d5bf8', component.options)
    }
    module.hot.accept("./close.vue?vue&type=template&id=1c6d5bf8&", function () {
      api.rerender('1c6d5bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/close.vue"
export default component.exports